import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/**
 * It is used to fetch available shipping optiosn for the shipment
 */
export const getShippingMethodsForShipment = async (appOrigin, token, basketId, shipmentId) => {
    const {app} = getConfig()
    const {organizationId, siteId} = app.commerceAPI.parameters
    try {
        const apiUrl = `${appOrigin}/mobify/proxy/api/checkout/shopper-baskets/v2/organizations/${organizationId}/baskets/${basketId}/shipments/${shipmentId}/shipping-methods?siteId=${siteId}`
        const shippingOptions = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }).then((res) => {
            return res.json()
        })

        return shippingOptions
    } catch (error) {
        console.log('getShippingMethodsForShipment: exception occured', error.message)
        return null
    }
}
